module.exports = __webpack_public_path__ + "img/icon_excel.3b3dd68.png";